/*
export const someAction = (state) => {}
 */
export var setCurrentNav = function setCurrentNav(state, data) {
  state.commit('SET_CURRENTNAV', data);
};
export var clearCurrentNav = function clearCurrentNav(state, data) {
  state.commit('CLEAR_CURRENTNAV', data);
};